import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

import { BiometricsFlow } from 'Store/userBiometrics/types';

export const selectBiometrics = createKeySelector('userBiometrics');

export const getBiometricsFlow = createSelector(
  selectBiometrics,
  (userBiometrics): BiometricsFlow => userBiometrics.flow
);

export const getIsBiometricsCompletedSuccess = createSelector(
  selectBiometrics,
  (userBiometrics): boolean => userBiometrics.isCompleted
);

export const getIsBiometricsInitialized = createSelector(
  selectBiometrics,
  (userBiometrics): boolean => userBiometrics.isInitialized
);
